/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { images } from "../../../config/images";
import { Button, Input } from "../../../components";
import { GetSportsForFacility } from "../../../utilities/api/sports/indext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { messages } from "../../../utilities/Messages";
const getMessage = messages.courts;

const CustomerCourtBookingStep1 = (props: any) => {
    const { courtBookingData, setCourtBookingData, setCurrentStep, setRules } = props
    const navigate = useNavigate()

    const [sportList, setSportList] = useState([]) as any

    const GetSport = async () => {
        const result = await GetSportsForFacility(courtBookingData.facilityId)
        if (result.statusCode == 200) {
            setSportList(result.data.rows)
        } else {
            toast.error(result.response.data.message);
        }
    }

    useEffect(() => {
        GetSport()
    }, [courtBookingData.facilityId])

    const handleCancel = () => {
        navigate("/customer-dashboard")
    }

    const handleContinue = () => {
        if (courtBookingData.sportId) {
            setRules(sportList.find((item: any) => item.id === courtBookingData.sportId)?.sportRules)
            setCurrentStep((_oldVal: number) => {
                if (_oldVal < 1) {
                    return ++_oldVal;
                } else {
                    return _oldVal;
                }
            })
        } else {
            toast.error(getMessage.sport_select)
        }
    }

    return (
        <>
            <Container fluid className="g-0">
                <Row className="row-mb g-4 align-items-center">
                    <Col lg={12}>
                        <div className="slot-selection">
                            <Row className="g-0">
                                <h4 className="fs-5 fw-semibold mb-4 text-start">Sports Around You</h4>
                                <label htmlFor="" className="form-label"></label>
                                <div className="available-slot d-flex flex-wrap gap-4">
                                    {sportList?.map((item: any, index: number) => {
                                        return (
                                            <span style={{ width: '154px' }} key={"sport" + index}>
                                                <Input onChange={(e: any) => setCourtBookingData({ ...courtBookingData, sportId: Number(e.target.value), selectedSlots: [] })} checked={courtBookingData.sportId == item.id} id={item.name} type="radio" name={item.name} className="btn-check" value={item.id} />
                                                <label htmlFor={item.name} className="bg-white border border-2 btn btn-sm p-4 w-100">
                                                    <div className="slot-box-crickt">
                                                        <img src={item.image || images.ballicon.default} alt={item.name + " logo"} style={{ width: '65px', height: '65px' }} />
                                                        <span className="d-block fs-6 mt-3">{item.name}</span>
                                                    </div>
                                                </label>
                                            </span>
                                        )
                                    })}
                                </div>
                            </Row>
                        </div>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col lg={6} className="text-start">
                        <Button onClick={handleCancel} type="button" bname="Cancel" name="cancel" id="cancel" className="btn btn-light rounded-1"></Button>
                    </Col>
                    <Col lg={6} className="text-end">
                        <Button onClick={handleContinue} type="button" bname="Continue" name="continue" id="continue" className="btn btn-primary rounded-1"></Button>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export { CustomerCourtBookingStep1 }
